function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 5px 0;\n  position: relative;\n  min-width: fit-content;\n  width: ", ";\n  max-width: calc(100vw);\n  overflow-x: auto;\n  &.bordered {\n    border: 1px solid ", ";\n  }\n  &.list {\n    background-color: #fafafa;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TableHeader from '../../molecules/TableHeader';
import TableRow from '../../molecules/TableRow';
import { defaultTheme } from '../../../utils';
var StyledTable = styled.div(_templateObject(), function (props) {
  return props.width;
}, function (props) {
  return props.theme.border;
});

var Table = function Table(_ref) {
  var width = _ref.width,
      variant = _ref.variant,
      data = _ref.data,
      headers = _ref.headers,
      rows = _ref.rows,
      handleScroll = _ref.handleScroll,
      classProps = _ref.classProps,
      isFetching = _ref.isFetching,
      rest = _objectWithoutPropertiesLoose(_ref, ["width", "variant", "data", "headers", "rows", "handleScroll", "classProps", "isFetching"]);

  var handleListScroll = function handleListScroll(event) {
    var elem = event.target;

    if (handleScroll && elem.scrollTop > 0.4 * (elem.scrollHeight - elem.clientHeight) && !isFetching && data.pageNo + 1 < data.totalPages) {
      handleScroll();
    }
  };

  return /*#__PURE__*/React.createElement(StyledTable, _extends({
    className: variant + " " + classProps,
    width: width,
    onScroll: function onScroll(evt) {
      return handleListScroll(evt);
    }
  }, rest), /*#__PURE__*/React.createElement(TableHeader, {
    headers: headers,
    variant: variant
  }), /*#__PURE__*/React.createElement("div", {
    className: "table-body"
  }, rows && rows.length > 0 && rows.map(function (rowData, index) {
    return /*#__PURE__*/React.createElement(TableRow, _extends({
      key: index,
      rowData: rowData,
      variant: variant
    }, rest));
  })));
};

Table.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.object,
  width: PropTypes.string,
  variant: PropTypes.string,
  headers: PropTypes.array,
  rows: PropTypes.array,
  handleScroll: PropTypes.func
} : {};
Table.defaultProps = {
  width: '100%',
  variant: 'bordered',
  data: {},
  headers: [],
  rows: [],
  classProps: '',
  isFetching: false,
  theme: defaultTheme
};
export default Table;